import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { Box, Modal, Paper, Typography } from '@mui/material'
import { Button } from '@/components/ui/button'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Select, { components } from 'react-select'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { useJoyRideContext } from '../context/JoyRideContext'
import { useParams } from 'react-router-dom'
import { IConfigSeller } from '@/models/configSeller'

type IData = {
  loading: boolean,
  open: boolean,
  form: {
    id_sbu: number,
    brand: { id_brand: number, discount: string, brand: string, value: string, label: string },
    model: { id_model: number, model: string, value: string, label: string, amount: number },
    capacity: { id_capacity: number, capacity: string, value: string, label: string }
  },
  brandList: any[],
  modelList: any[],
  capacityList: any[]
}

const CheckFeasibility = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const userState = useSelector((store: IAppStore) => store.user)
  const [approved, setApproved] = useState(false)
  const [data, setData] = useState<IData>({
    loading: false,
    open: false,
    form: {
      id_sbu: ctx.tradein.id_sbu,
      brand: { id_brand: 0, discount: '', brand: '', value: '', label: '' },
      model: { id_model: 0, model: '', value: '', label: '', amount: 0 },
      capacity: { id_capacity: 0, capacity: '', value: '', label: '' }
    },
    brandList: [],
    modelList: [],
    capacityList: []
  })
  const { enqueueSnackbar } = useSnackbar()
  const { slug } = useParams<{ slug: string, id: string }>()
  // Fuera de la ruta del detalle (modal del listado) el id no viene en la url: todas las llamadas
  // usan ctx.tradein.id, que sirve en ambos casos.

  const isCoppelMx = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const { setRunTour, setSteps } = useJoyRideContext()

  const handleClose = () => {
    setData({ ...data, open: false })
  }

  const loadData = async () => {
    setData({ ...data, open: true, loading: true })
    try {
      const res : any = await webApiService.getAllBrandBySbu(String(data.form.id_sbu), String(slug))
      let res2: any

      if (isCoppelMx) {
        res2 = await webApiService.getAllCapacityByModel({
          idSbu: String(data.form.id_sbu),
          idBrand: String(data.form.brand.id_brand),
          idModel: String(data.form.model.id_model),
          seller: String(slug)
        })
        console.log('res2 capacitylist =>', res2)
      }
      let modelList: any[]

      if (res.data.map((item: any) => { return { ...item, value: item.id_brand, label: item.brand } }).find((e: any) => e.brand.toUpperCase() === ctx.tradein.brand.toUpperCase()) !== undefined) {
        const marca = res.data.map((item: any) => { return { ...item, value: item.id_brand, label: item.brand } }).find((e: any) => e.brand.toUpperCase() === ctx.tradein.brand.toUpperCase())
        console.log('🚀 ~ loadData ~ marca:', marca)
        modelList = await webApiService.getAllModelByBrand(String(data.form.id_sbu), marca.id_brand, String(slug)).then(res => res.data.map((item: any) => { return { ...item, value: item.id_model, label: item.model } }))
      } else {
        modelList = []
      }
      console.log('🚀 ~ loadData ~ modelList:', modelList)

      setData({
        ...data,
        open: true,
        loading: false,
        brandList: res.data.map((item: any) => { return { ...item, value: item.id_brand, label: item.brand } }),
        form: { ...data.form, brand: res.data.map((item: any) => { return { ...item, value: item.id_brand, label: item.brand } }).find((e: any) => e.brand.toUpperCase() === ctx.tradein.brand.toUpperCase()) },
        modelList,
        // modelList: res[2].data.map((item: any) => { return { ...item, value: item.id_model, label: item.model } }),
        capacityList: isCoppelMx ? res2.data.map((item: any) => { return { ...item, value: item.id_capacity, label: item.capacity } }) : []
      })
    } catch (error: any) {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    }
  }

  const handleBrandChange = (value: any) => {
    console.log('value => ', value)
    setData(prev => ({
      ...prev,
      loading: true,
      form: {
        ...prev.form,
        brand: value,
        model: { id_model: 0, model: '', value: '', label: '', amount: 0 },
        capacity: { id_capacity: 0, capacity: '', value: '', label: '' }
      },
      modelList: [],
      capacityList: []
    }))
    webApiService.getAllModelByBrand(String(data.form.id_sbu), String(value.id_brand), String(slug)).then(res => {
      if (res.success) {
        setData(prev => ({
          ...prev,
          modelList: res.data.map((item: any) => ({ ...item, value: item.id_model, label: item.model })),
          loading: false
        }))
      }
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData(prev => ({ ...prev, loading: false }))
    })
  }

  /* const handleModelChange = (value: any) => {
    console.log('🚀 ~ handleModelChange ~ value:', value)
    setData({ ...data, form: { ...data.form, model: value } })
  } */

  const handleModelChange = async (value: any) => {
    console.log('🚀 ~ handleModelChange ~ value:', value)

    // Primero actualizamos el formulario y limpiamos la capacidad
    if (isCoppelMx) {
      setData({
        ...data,
        loading: true,
        form: {
          ...data.form,
          model: value,
          capacity: { id_capacity: 0, capacity: '', value: '', label: '' } // limpiar
        },
        capacityList: [] // limpiar la lista mientras se carga
      })
      try {
        // Obtenemos las capacidades del modelo seleccionado
        const res = await webApiService.getAllCapacityByModel({
          idSbu: String(data.form.id_sbu),
          idBrand: String(data.form.brand.id_brand),
          idModel: String(value.id_model),
          seller: String(slug)
        })

        if (res.success) {
          setData({
            ...data,
            loading: false,
            form: {
              ...data.form,
              model: value
            },
            capacityList: res.data.map((item: any) => ({
              ...item,
              value: item.id_capacity,
              label: item.capacity
            }))
          })
        } else {
          setData({ ...data, loading: false })
        }
      } catch (error: any) {
        console.error('Error cargando capacdades:', error)
        enqueueSnackbar(error.message, { variant: 'error' })
        setData({ ...data, loading: false })
      }
    } else {
      console.log('🚀 ~ handleModelChange ~ value:', value)
      setData({ ...data, form: { ...data.form, model: value } })
    }
  }

  const handleCapacityChange = (value: any) => {
    console.log('🚀 ~ handleCapacityChange ~ value:', value)
    setData({ ...data, form: { ...data.form, capacity: value } })
  }

  const CustomOption = (props: any) => {
    const { data } = props
    // eslint-disable-next-line no-debugger
    // debugger
    return (
      <components.Option {...props}>
        {data.label}
      </components.Option>
    )
  }

  const handleUpdate = async () => {
    setData({ ...data, loading: true })
    await webApiService.updatePCheck({ make: data.form.brand.brand, modelName: data.form.model.model, memory: (data.form.capacity.capacity) ? data.form.capacity.capacity : '', loginCode: ctx.tradein.login_code, id_user: userState.id, id_tradein: ctx.tradein.id }).then(res => {
      if (res.success) {
        saveCtx({ ...ctx, reload: true })
      }
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    })
  }

  const checkApproved = async () => {
    const History : any = await webApiService.getHistoryById(String(ctx.tradein.id)).then(res => res.data)
    console.log('🚀 ~ loadData ~ History:', History)

    const hasApproved : boolean = History.filter((e: any) => e.id_status === 2).length > 0
    setApproved(hasApproved)
  }

  useEffect(() => {
    checkApproved()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // JoyRide: mostrar paso cuando el botón Revisar Factibilidad es visible
  useEffect(() => {
    if (approved) {
      setSteps([
        {
          target: '.joyride-factibilidad-btn',
          content: 'Presiona este botón para revisar la factibilidad del equipo.',
          placement: 'bottom',
          disableBeacon: true
        }
      ])
      setRunTour(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approved])

  return (
    <div hidden={!approved}>
      <Button
        disabled={!approved}
        type='submit'
        size='sm'
        legacyColor='default'
        legacyVariant='shadow'
        className='joyride-factibilidad-btn'
        onClick={() => {
          loadData()
        }}
      >
        Revisar Factibilidad
      </Button>
      <Modal open={data.open} onClose={handleClose}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            p: 2
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: '800px',
              backgroundColor: 'white',
              borderRadius: 2,
              textAlign: 'center'
            }}
          >
            <Typography
              id='modal-title'
              variant='h6'
              component='h2'
              sx={{
                backgroundColor: '#333',
                color: '#fff',
                width: '100%',
                padding: 2
              }}
            >
              Revisar Factibilidad:
            </Typography>
            <Paper variant='outlined' sx={{ padding: 2 }} className='small'>
              <p className='text-start mb-2'>Modelo encontrado en Phonecheck:</p>
              <p className='text-start mb-1'>Marca: <span className='fw-bold'>{ctx.tradein.make}</span></p>
              <p className='text-start mb-1'>Modelo: <span className='fw-bold'>{ctx.tradein.modelName}</span></p>
              <p className='text-start mb-1'>Número Modelo: <span className='fw-bold'>{ctx.tradein.modelNo}</span></p>
              <div className='text-start mb-2'>
                <p className='text-start mb-1'>Seleccione marca:</p>
                <Select
                  components={{ Option: CustomOption }}
                  isLoading={data.loading}
                  isDisabled={data.loading}
                  options={data.brandList}
                  value={
                    data.form.brand && data.form.brand.id_brand !== 0
                      ? data.brandList.find((b: any) => b.id_brand === data.form.brand.id_brand) || null
                      : null
                  }
                  onChange={handleBrandChange}
                  placeholder='Seleccione una marca...'
                />
              </div>
              <div className='text-start mb-2'>
                <p className='text-start mb-1'>Seleccione modelo:</p>
                <Select
                  components={{ Option: CustomOption }}
                  isLoading={data.loading}
                  isDisabled={data.loading}
                  options={data.modelList}
                  value={data.form.model}
                  onChange={(value) => handleModelChange(value)}
                  placeholder='Seleccione un modelo...'
                />
              </div>
              {
                isCoppelMx && (
                  <div className='text-start mb-2'>
                    <p className='text-start mb-1'>Seleccione la capacidad:</p>
                    <Select
                      components={{ Option: CustomOption }}
                      isLoading={data.loading}
                      isDisabled={data.loading}
                      options={data.capacityList}
                      value={data.form.capacity}
                      onChange={(value) => handleCapacityChange(value)}
                      placeholder='Seleccione una capacidad'
                    />
                  </div>
                )
              }
            </Paper>
            <Box
              sx={{
                backgroundColor: '#f1f1f1',
                width: '100%',
                padding: 2,
                borderBottomLeftRadius: 5,
                borderBottomRightRadius: 5,
                display: 'flex',
                justifyContent: 'center',
                gap: 2
              }}
            >
              <Button
                variant='destructive'
                onClick={handleClose}
              >
                Cerrar
              </Button>
              <Button disabled={data.loading} type='submit' onClick={handleUpdate}>
                {data.loading ? 'Guardando...' : 'Guardar Modelo'}
              </Button>
            </Box>
          </Box>

        </Box>
      </Modal>
    </div>
  )
}

export default CheckFeasibility
